module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mdl-layout__content"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.latest_report_id) ? _c('p', {
    staticClass: "warning-headline"
  }, [(_vm.isEuropcarReport() || _vm.isAldReport()) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Kjøretøyet er registrert tidligere'))
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Det finnes allerede en'))
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "target": "_blank",
      "to": {
        name: 'report',
        params: {
          id: _vm.latest_report_id
        }
      }
    }
  }, [_vm._v("takst")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('på dette kjøretøyet'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "mdl-typography--headline",
    domProps: {
      "textContent": _vm._s(_vm.translate('1. Kontaktinfo'))
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [(!_vm.isEuropcarReport() && !_vm.isAldReport() && !_vm.isRentalCheckReport()) ? [_c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Mottaker'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [(!_vm.$root.isClient()) ? [_c('div', {
    staticClass: "mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-select', {
    attrs: {
      "onChange": _vm.onClientChange,
      "disabled": !_vm.isEditable(),
      "placeholder": "Velg mottaker",
      "label": "name",
      "options": _vm.clients
    },
    model: {
      value: (_vm.client),
      callback: function($$v) {
        _vm.client = $$v
      },
      expression: "client"
    }
  })], 1), _vm._v(" "), (_vm.errors.id_client) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.id_client)
    }
  }) : _vm._e()] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [(_vm.isEuropcarReport() || _vm.isAldReport() || _vm.isRentalCheckReport()) ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Rapporttype:'))
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-radio mdl-js-radio mdl-js-ripple-effect",
    attrs: {
      "for": "status-check-out"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_status),
      expression: "report.report_status"
    }],
    staticClass: "mdl-radio__button",
    attrs: {
      "type": "radio",
      "id": "status-check-out",
      "name": "report_status",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.report.report_status, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.report, "report_status", "5")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-radio__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Utsjekk'))
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "mdl-radio mdl-js-radio mdl-js-ripple-effect",
    attrs: {
      "for": "status-check-in"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_status),
      expression: "report.report_status"
    }],
    staticClass: "mdl-radio__button",
    attrs: {
      "type": "radio",
      "id": "status-check-in",
      "name": "report_status",
      "value": "4",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.report.report_status, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.report, "report_status", "4")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-radio__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Innsjekk'))
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isAldReport()) ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('label', {}, [_vm._v("Recipient type:")]), _vm._v(" "), _c('label', {
    staticClass: "mdl-radio mdl-js-radio mdl-js-ripple-effect",
    attrs: {
      "for": "status-swap"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.recipient_status),
      expression: "report.recipient_status"
    }],
    staticClass: "mdl-radio__button",
    attrs: {
      "type": "radio",
      "id": "status-swap",
      "name": "recipient_status",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.report.recipient_status, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.report, "recipient_status", "1")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-radio__label"
  }, [_vm._v("Swap")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-radio mdl-js-radio mdl-js-ripple-effect",
    attrs: {
      "for": "status-flexible"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.recipient_status),
      expression: "report.recipient_status"
    }],
    staticClass: "mdl-radio__button",
    attrs: {
      "type": "radio",
      "id": "status-flexible",
      "name": "recipient_status",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.report.recipient_status, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.report, "recipient_status", "2")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-radio__label"
  }, [_vm._v("Flexible")])]), _vm._v(" "), (_vm.errors.recipient_status) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.recipient_status)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "mdl-typography--title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('Kontaktperson'))
    }
  }), _vm._v(" "), (_vm.isEuropcarReport()) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.translate('/ Sted / Stasjon'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.contact_name),
      expression: "report.contact_name"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": (_vm.report.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "contact_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Kontaktperson'))
    }
  })]), _vm._v(" "), (_vm.errors.contact_name) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.contact_name)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.contact_phone),
      expression: "report.contact_phone"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample2"
    },
    domProps: {
      "value": (_vm.report.contact_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "contact_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample2"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Mobil'))
    }
  })]), _vm._v(" "), (_vm.errors.contact_phone) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.contact_phone)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.contact_email),
      expression: "report.contact_email"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample3"
    },
    domProps: {
      "value": (_vm.report.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "contact_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample3"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Epost'))
    }
  })]), _vm._v(" "), (_vm.errors.contact_email) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.contact_email)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.firma),
      expression: "report.firma"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "sample4"
    },
    domProps: {
      "value": (_vm.report.firma)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "firma", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample4"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Firma'))
    }
  })]), _vm._v(" "), (_vm.errors.firma) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.firma)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.isRegularReport() || _vm.$root.isSurveyorCapability() || _vm.isEuropcarReport() || _vm.isAldReport() || _vm.isRentalReport()) ? [_c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Rapportvalg'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [(_vm.isRegularReport() || _vm.$root.isSurveyorCapability()) ? [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.referral_number),
      expression: "report.referral_number"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "id": "referral_number"
    },
    domProps: {
      "value": (_vm.report.referral_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "referral_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "referral_number"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Referanse / Kontaktsnummer'))
    }
  })]), _vm._v(" "), (_vm.$root.isSurveyorCapability() && !_vm.isReportClient('nettbil')) ? _c('div', [_c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "without_price"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.without_price),
      expression: "report.without_price"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "without_price"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.without_price) ? _vm._i(_vm.report.without_price, null) > -1 : (_vm.report.without_price)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.without_price,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "without_price", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "without_price", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "without_price", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Taksering uten pris/kostnad'))
    }
  })])])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isRegularReport() || _vm.$root.isSurveyorCapability() || _vm.isEuropcarReport() || _vm.isAldReport() || _vm.isRentalReport()) ? _c('div', [_c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "english_report"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_language),
      expression: "report.report_language"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "english_report",
      "true-value": "en",
      "false-value": "no"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.report_language) ? _vm._i(_vm.report.report_language, null) > -1 : _vm._q(_vm.report.report_language, "en")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.report_language,
          $$el = $event.target,
          $$c = $$el.checked ? ("en") : ("no");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "report_language", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "report_language", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "report_language", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Engelsk rapport'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "danish_report"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_language),
      expression: "report.report_language"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "danish_report",
      "true-value": "da",
      "false-value": "no"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.report_language) ? _vm._i(_vm.report.report_language, null) > -1 : _vm._q(_vm.report.report_language, "da")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.report_language,
          $$el = $event.target,
          $$c = $$el.checked ? ("da") : ("no");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "report_language", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "report_language", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "report_language", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Dansk rapport'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "swedish_report"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_language),
      expression: "report.report_language"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "swedish_report",
      "true-value": "sv",
      "false-value": "no"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.report_language) ? _vm._i(_vm.report.report_language, null) > -1 : _vm._q(_vm.report.report_language, "sv")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.report_language,
          $$el = $event.target,
          $$c = $$el.checked ? ("sv") : ("no");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "report_language", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "report_language", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "report_language", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Svensk rapport'))
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.isRegularReport()) ? _c('div', [_c('div', {
    staticClass: "mdl-textfield"
  }, [_c('label', {
    staticClass: "mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect",
    attrs: {
      "for": "is_condition_report"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.is_condition_report),
      expression: "report.is_condition_report"
    }],
    staticClass: "mdl-checkbox__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "type": "checkbox",
      "id": "is_condition_report"
    },
    domProps: {
      "checked": Array.isArray(_vm.report.is_condition_report) ? _vm._i(_vm.report.is_condition_report, null) > -1 : (_vm.report.is_condition_report)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.report.is_condition_report,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.report, "is_condition_report", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.report, "is_condition_report", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.report, "is_condition_report", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-checkbox__label",
    domProps: {
      "textContent": _vm._s(_vm.translate('Inkluder Teknisk Inspeksjon'))
    }
  })])])]) : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Info om bil'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [(_vm.isEuropcarReport() || _vm.isAldReport()) ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.referral_number),
      expression: "report.referral_number"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "off",
      "type": "text",
      "id": "contract_referral_number"
    },
    domProps: {
      "value": (_vm.report.referral_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "referral_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "contract_referral_number"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Kontrakstnummer'))
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.id_car),
      expression: "report.id_car"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "off",
      "type": "text",
      "id": "sample5"
    },
    domProps: {
      "value": (_vm.report.id_car)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "id_car", $event.target.value)
      }, _vm.getLatestReport]
    }
  }), _vm._v(" "), (_vm.car.model) ? _c('p', {
    staticStyle: {
      "margin": "0"
    },
    domProps: {
      "textContent": _vm._s(_vm.car.producer + ' ' + _vm.car.model + ' ' + _vm.car.year)
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample5"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Reg.Nr'))
    }
  })]), _vm._v(" "), (_vm.errors.id_car) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.id_car)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.car_mileage),
      expression: "report.car_mileage"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "off",
      "type": "text",
      "id": "sample6"
    },
    domProps: {
      "value": (_vm.report.car_mileage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "car_mileage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample6"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Kilometerstand'))
    }
  })]), _vm._v(" "), (_vm.errors.car_mileage) ? _c('div', {
    staticClass: "v-error",
    domProps: {
      "textContent": _vm._s(_vm.errors.car_mileage)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isEuropcarReport() && !_vm.isAldReport()) ? _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.car_market),
      expression: "report.car_market"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "off",
      "type": "text",
      "id": "sample7"
    },
    domProps: {
      "value": (_vm.report.car_market)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "car_market", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample7"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Markedsverdi'))
    }
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isEuropcarReport() && !_vm.isAldReport()) ? [_c('h2', {
    staticClass: "mdl-typography--title",
    domProps: {
      "textContent": _vm._s(_vm.translate('Servicehistorikk'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contact-info mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.service_history_description),
      expression: "report.service_history_description"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "disabled": !_vm.isEditable(),
      "autocomplete": "off",
      "type": "text",
      "id": "service_history_description"
    },
    domProps: {
      "value": (_vm.report.service_history_description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.report, "service_history_description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "service_history_description"
    },
    domProps: {
      "textContent": _vm._s(_vm.translate('Eventuelt avvik'))
    }
  })]), _vm._v(" "), _vm._l((_vm.report.service_history), function(shItem, shIndex) {
    return _c('div', [_c('div', {
      staticClass: "mdl-cell--4-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shItem[0]),
        expression: "shItem[0]"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "disabled": !_vm.isEditable(),
        "autocomplete": "off",
        "type": "text",
        "id": 'sh_date_' + shIndex
      },
      domProps: {
        "value": (shItem[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shItem, 0, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'sh_date_' + shIndex
      },
      domProps: {
        "textContent": _vm._s(_vm.translate('Dato'))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mdl-cell--4-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shItem[1]),
        expression: "shItem[1]"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "disabled": !_vm.isEditable(),
        "autocomplete": "off",
        "type": "text",
        "id": 'sh_km_' + shIndex
      },
      domProps: {
        "value": (shItem[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shItem, 1, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'sh_km_' + shIndex
      }
    }, [_vm._v("Km")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--4-col"
  }, [_c('div', {
    staticClass: "mdl-button mdl-js-button mdl-button--icon green",
    on: {
      "click": function($event) {
        return _vm.addServiceHistoryItem()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("playlist_add")])])])], 2)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-bar"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey",
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }, [_vm._v(_vm._s(_vm.translate('Avbryt')))]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored-green",
    attrs: {
      "disabled": _vm.$root.ui.isLoading('sendReport')
    },
    on: {
      "click": function($event) {
        return _vm.start()
      }
    }
  }, [_vm._v(_vm._s(_vm.translate('Til Nøkler og ustyr')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659c87d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./reports/assets/src/components/ContactForm.vue
// module id = 67
// module chunks = 0